var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLanguageTranslate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.855 15.67C12.995 15.31 12.905 14.9 12.625 14.62L10.535 12.56L10.565 12.53C12.305 10.59 13.545 8.36 14.275 6H16.215C16.755 6 17.205 5.55 17.205 5.01V4.99C17.205 4.45 16.755 4 16.215 4H10.205V3C10.205 2.45 9.75496 2 9.20496 2C8.65496 2 8.20496 2.45 8.20496 3V4H2.19496C1.65496 4 1.20496 4.45 1.20496 4.99C1.20496 5.54 1.65496 5.98 2.19496 5.98H12.375C11.705 7.92 10.645 9.75 9.20496 11.35C8.39496 10.46 7.71496 9.49 7.14496 8.47C6.98496 8.18 6.69496 8 6.36496 8C5.67496 8 5.23496 8.75 5.57496 9.35C6.20496 10.48 6.97496 11.56 7.87496 12.56L3.50496 16.87C3.10496 17.26 3.10496 17.9 3.50496 18.29C3.89496 18.68 4.52496 18.68 4.92496 18.29L9.20496 14L11.225 16.02C11.735 16.53 12.605 16.34 12.855 15.67ZM17.705 10C17.105 10 16.565 10.37 16.355 10.94L12.685 20.74C12.445 21.35 12.905 22 13.555 22C13.945 22 14.295 21.76 14.435 21.39L15.325 19H20.075L20.975 21.39C21.115 21.75 21.465 22 21.855 22C22.505 22 22.965 21.35 22.735 20.74L19.065 10.94C18.845 10.37 18.305 10 17.705 10ZM17.705 12.67L16.085 17H19.325L17.705 12.67Z",
    fill: "#4E5968"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguageTranslate);
export default __webpack_public_path__ + "static/media/LanguageTranslate.64a7f394acf6de27ffc4000b754f7857.svg";
export { ForwardRef as ReactComponent };